import React from 'react';
import ReactDOM from 'react-dom/client';
import { Root } from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-275">
    <Root data-id="element-276" />
  </React.StrictMode>);